import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api";
import { handleResponseError } from '../../utils/helpers/network-error';

export const createHour = createAsyncThunk('hours.create', async ({
  formData, onSuccess, onFailure
}, { rejectWithValue }) => {
  try {
    const { data: { newHour, message } } = await api.hours.create(formData);
    onSuccess(message);
    return newHour;
  } catch (error) {
    handleResponseError(error, onFailure);
    return rejectWithValue();
  }
});

export const updateHour = createAsyncThunk('hours.update', async ({
  formData, onSuccess, onFailure
}, { rejectWithValue }) => {
  try {
    const { _id, ...rest } = formData;

    const formDataWithoutEmptyFields = Object.keys(rest).reduce((acc, key) => {
      if (rest[key]) {
        acc[key] = rest[key];
      }
      return acc;
    }, {});

    const { data: { updatedHour, message } } = await api.hours.update(_id, formDataWithoutEmptyFields);
    onSuccess(message);
    return updatedHour;
  } catch (error) {
    handleResponseError(error, onFailure);
    return rejectWithValue();
  }
});

export const getHours = createAsyncThunk('hours.getHours', async ({
  page, limit, search, dateRange
}, { rejectWithValue }) => {
  try {
    const queryParams = {
      page,
      limit,
    };

    if (search && search.trim().length > 0) {
      queryParams.search = search.trim();
    }

    if (dateRange) {
      queryParams.startDate = dateRange.startDate;
      queryParams.endDate = dateRange.endDate;
    }

    const { data: { hours, totalMinutes, totalDocs } } = await api.hours.getHours(queryParams);

    return {
      hours,
      totalMinutes,
      totalDocs,
    };
  } catch (error) {
    handleResponseError(error);
    return rejectWithValue();
  }
});

export const deleteHours = createAsyncThunk('hours.deleteHours', async ({
  ids, onSuccess, onFailure
}, { rejectWithValue }) => {
  try {
    const { data: { message } } = await api.hours.deleteHours(ids);
    onSuccess(message);
    return ids;
  } catch (error) {
    handleResponseError(error, onFailure);
    return rejectWithValue();
  }
});
